function getTimeString({ hours, minutes, seconds }): string {
  const hoursPad = String(hours).padStart(2, '0');
  const minutesPad = String(minutes).padStart(2, '0');
  const secondsPad = String(seconds).padStart(2, '0');
  return `${hoursPad}:${minutesPad}:${secondsPad}`;
}

export default getTimeString;
